<script>
import { Helper } from '@/mixin/helper'
import { getClient } from '@/services/identity'
import RestEditableTable from '@/components/RestEditableTable'
import * as metabaseDeashboardLinkApi from '../lib/metabaseDashboardLink'
import { mapGetters } from 'vuex'

const identityClient = getClient()

export default {
  components: {
    RestEditableTable,
  },
  mixins: [Helper],
  data() {
    return {
      isTableDataAvailable: true,
      attachedListeners: new Set(), // Track listeners yang sudah attached
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    title() {
      return 'Jenis Kendaraan'
    },

    fields() {
      return [
        {
          key: 'id',
          editable: false,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'dashboard_name',
          thClass: 'mc-table--150',
          editable: true,
          label: 'Page Name',
          placeholder: 'Status',
          _type: 'text',
          validation: [['required']],
        },
        {
          key: 'access_name',
          thClass: 'mc-table--150',
          editable: false,
          label: 'Access Name',
        },
        {
          key: 'dashboard_link',
          thClass: 'mc-table--150',
          editable: true,
          label: 'Link',
          placeholder: 'Desc',
          _type: 'text',
          validation: [['required']],
        },
        {
          key: 'icon',
          editable: true,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
      ]
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    apiClient() {
      return {
        get: metabaseDeashboardLinkApi.get,
        show: metabaseDeashboardLinkApi.show,
        store: metabaseDeashboardLinkApi.store,
        delete: metabaseDeashboardLinkApi.deleteMany,
        update: metabaseDeashboardLinkApi.update,
      }
    },
    queries() {
      return {
        deviceTypes: async (opts) => {
          if (opts) {
            const { limit = 10, page = 1, search = '' } = opts;
            const deviceTypes = metabaseDeashboardLinkApi.constants.data.deviceTypes;

            const filteredDeviceTypes = deviceTypes.filter((device) =>
              device.device_name.toLowerCase().includes(search.toLowerCase())
            );

            const startIndex = (page - 1) * limit;
            const paginatedResult = filteredDeviceTypes.slice(startIndex, startIndex + limit);

            const res = {
              metadata: {
                total_page: Math.ceil(filteredDeviceTypes.length / limit),
                total_count: filteredDeviceTypes.length,
                count: paginatedResult.length,
                page: page,
              },
              data: {
                paginated_result: paginatedResult,
              },
            };

            return res;
          }
        },
        subscriptionType: async (opts) => {
          if (opts) {
            const subscription = await identityClient.get(
              `api/subscription?page=${opts?.page.toString()}&limit=${opts?.limit.toString()
              }&_subscription(subscription,like)=${opts?.search || ''}`
            )

            const paginatedResult = subscription?.data.data.pagination_result ?? []

            const res = {
              metadata: {
                total_page: subscription?.data.metadata.total_page,
                total_count: subscription?.data.metadata.total_count,
                count: paginatedResult.length,
                page: subscription?.data.metadata.page,
              },
              data: {
                paginated_result: paginatedResult,
              },
            }

            return res
          }
        },
        metabaseDeashboardLinkOpt: (opts) => {
          const { limit = 10, page = 1, search = '' } = opts || {};
          const intervals = metabaseDeashboardLinkApi.constants.data.intervals;

          const filteredIntervals = intervals.filter((interval) =>
            interval.interval_name.toLowerCase().includes(search.toLowerCase())
          );

          const startIndex = (page - 1) * limit;
          const paginatedResult = filteredIntervals.slice(startIndex, startIndex + limit);

          const res = {
            data: paginatedResult,
            has_more: page * limit < filteredIntervals.length,
            page: page,
            size: paginatedResult.length,
            total_count: filteredIntervals.length,
            total_page: Math.ceil(filteredIntervals.length / limit),
          };

          return res;
        }
      }
    },
    exception() {
      const exceptionFields = ['manufacturer']
      return exceptionFields
    },
  },
  beforeDestroy() {
    // ✨ Cleanup: Clear semua attached listeners
    this.attachedListeners.clear()
  },
  methods: {
    async handleDragEnd({ oldIndex, newIndex, item }) {
      const payload = {
        dashboard_name: item.dashboard_name,
        dashboard_link: item.dashboard_link,
        sort_order: newIndex + 1,
      }
      try {
        await metabaseDeashboardLinkApi.updateSorting(item.metabase_dashboard_link_id, payload)
        this.$toast.success('Urutan berhasil disimpan')

        // 🔄 Refresh tabel agar urutan sesuai backend
        const table = this.$refs.metabaseDeashboardLinkRef
        if (table && table.getData) {
          await table.getData({
            size: table.limit,
            page: table.page,
            // jika ada filter atau search yang perlu dipertahankan, tambahkan di sini
          })
        }
      } catch (err) {
        // ❌ Gagal: balikkan posisi item ke semula (revert)
        const table = this.$refs.metabaseDeashboardLinkRef
        if (table && table.items) {
          const movedItem = table.items[newIndex]
          table.items.splice(newIndex, 1)
          table.items.splice(oldIndex, 0, movedItem) // oldIndex tersedia dari parameter event
        }
        this.$toast.error('Gagal menyimpan urutan')
      }
    },
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    isContains(search, name) {
      const searchContains = RegExp(search ?? '', 'gi').exec(name ?? '')
      return searchContains != null && searchContains.length > 0
    },
    async handleChange() {
      try {
        // ✨ FIX 1: Safety check - pastikan refs ada
        if (!this.$refs.metabaseDeashboardLinkRef) {
          console.warn('[MetabaseDashboardLink] ref not found')
          return
        }

        const metabaseDeashboardLinkRef = this.$refs.metabaseDeashboardLinkRef.$refs

        // ✨ FIX 2: Safety check - pastikan $refs ada
        if (!metabaseDeashboardLinkRef) {
          console.warn('[MetabaseDashboardLink] $refs not found')
          return
        }

        await this.$nextTick()

        // ✨ FIX 3: Iterate dengan safety check
        this.fields.forEach((field) => {
          if (!field.editable) return

          try {
            // Get field ref
            const fieldRef = metabaseDeashboardLinkRef[`${field.key}-ref`]

            // ✨ FIX 4: Check if ref exists
            if (!fieldRef) {
              console.warn(`[MetabaseDashboardLink] Field ref '${field.key}' not found`)
              return
            }

            // ✨ FIX 5: Check if $el exists
            if (!fieldRef.$el) {
              console.warn(`[MetabaseDashboardLink] Field $el '${field.key}' not found`)
              return
            }

            // ✨ FIX 6: Check if listener already attached (prevent duplicates)
            const listenerKey = `${field.key}-preventTabKey`
            if (this.attachedListeners.has(listenerKey)) {
              return // Skip jika sudah attached
            }

            // ✨ FIX 7: Check if Helper methods exist
            if (!Helper?.methods?.preventTabKey) {
              console.warn('[MetabaseDashboardLink] Helper.methods.preventTabKey not found')
              return
            }

            // ✨ FIX 8: Try-catch untuk addEventListener
            try {
              fieldRef.$el.addEventListener(
                'keydown',
                Helper.methods.preventTabKey
              )
              this.attachedListeners.add(listenerKey) // Mark sebagai attached
              console.debug(`[MetabaseDashboardLink] Listener attached: ${field.key}`)
            } catch (error) {
              console.error(`[MetabaseDashboardLink] Error attaching listener to ${field.key}:`, error)
            }
          } catch (error) {
            console.error(`[MetabaseDashboardLink] Error in field iteration:`, error)
          }
        })
      } catch (error) {
        console.error('[MetabaseDashboardLink] Error in handleChange:', error)
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="card">
      <div class="card-body">
        <RestEditableTable ref="metabaseDeashboardLinkRef" :fields="fields" :apiClient="apiClient" draggable
          @drag-end="handleDragEnd" :bulkDeleteApi="true" :hidePagination="true" :showNoData="!isTableDataAvailable"
          :enableDeleteButton="hasAccessAll(['metabase-dashboard-link:delete'])"
          :enableAddButton="hasAccessAll(['metabase-dashboard-link:create'])"
          :isEnableEditButton="hasAccessAll(['metabase-dashboard-link:update'])" @available-change="handleDataAvailable"
          trackBy="metabase_dashboard_link_id" @changeData="handleChange" />
      </div>
    </div>
  </div>
</template>
